"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postAsset = exports.postAssets = void 0;
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const postAssets = (assets) => __awaiter(void 0, void 0, void 0, function* () {
    const uploadedAssets = assets.map((asset) => {
        return (0, exports.postAsset)(asset);
    });
    const resArray = yield Promise.all(uploadedAssets);
    return resArray.map((res) => {
        const data = res.data;
        // TODO: fix relative namespace at back-end
        if (!res.data.uri.match("app.thefeedfactory")) {
            data.uri = "https://app.thefeedfactory.nl" + data.uri;
        }
        return data;
    });
});
exports.postAssets = postAssets;
const postAsset = (asset) => {
    return postAssetPromise(asset);
};
exports.postAsset = postAsset;
const postAssetPromise = (asset) => {
    const formData = new FormData();
    formData.append("file", asset);
    return feed_factory_helpers_1.feedFactoryAxios.post("assets", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};
//# sourceMappingURL=postAsset.js.map